import React from 'react'
import { Box } from '@mui/material'
import { keyframes } from '@mui/material/styles'

interface PulsingIconProps {
  IconComponent: React.ElementType // El componente del icono a utilizar
  maxScale?: number // Tamaño máximo del icono durante la animación
  duration?: string // Duración de la animación (por ejemplo, "1.5s")
  initialColor?: string // Color inicial del icono durante la animación
  finalColor?: string // Color final del icono durante la animación
  initialOpacity?: number // Opacidad inicial del icono durante la animación
  finalOpacity?: number // Opacidad final del icono durante la animación
  fontSize?: 'small' | 'inherit' | 'default' | 'large' // Tamaño del icono
  color?: string // Color base del ícono fuera de la animación
}

const PulsingIcon: React.FC<PulsingIconProps> = ({
  IconComponent,
  maxScale = 2, // Valor predeterminado para maxScale
  duration = '1.5s', // Valor predeterminado para la duración de la animación
  initialColor = 'grey', // Valor predeterminado para el color inicial
  finalColor = 'black', // Valor predeterminado para el color final
  initialOpacity = 0.5, // Valor predeterminado para la opacidad inicial
  finalOpacity = 1, // Valor predeterminado para la opacidad final
  fontSize = 'large', // Tamaño del icono por defecto
  color = 'inherit' // Color base del ícono fuera de la animación
}) => {
  // Tamaño de escala máximo que será utilizado para ajustar el tamaño del contenedor
  const containerScale = maxScale > 1 ? maxScale : 1
  const pulse = keyframes({
    '0%': {
      transform: 'scale(1)',
      color: initialColor,
      opacity: initialOpacity
    },
    '50%': {
      transform: `scale(${maxScale})`,
      color: finalColor,
      opacity: finalOpacity
    },
    '100%': {
      transform: 'scale(1)',
      color: initialColor,
      opacity: initialOpacity
    }
  })

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: `calc(${containerScale} * 48px)`,
        height: `calc(${containerScale} * 48px)`
      }}
    >
      <Box
        component={IconComponent}
        fontSize={fontSize}
        sx={{
          animation: `${pulse} ${duration} ease-in-out infinite`,
          color
        }}
      />
    </Box>
  )
}

export default PulsingIcon
